import React from 'react';
import PropTypes from 'prop-types';
import { defaultTemplate } from 'core/hoc';
import { BaasicFormControls, BasicTextArea, BaasicButton } from 'core/components';

function FacilityOrderTemplateAddNoteModalTemplate({ facilityOrderTemplateAddNoteModalStore , t}) {
    const {
        isEdit,
        form,
        modalParams
    } = facilityOrderTemplateAddNoteModalStore;

    return (
        <section className='w--400--px'>
            <div className="modal__header">
                <h3 className='modal__header__title'>{ isEdit ? "Edit Note" : "Add Note" }</h3>
            </div>
            <div className="modal__body">
                <div className="form__group">
                    <BasicTextArea field={form.$('note')} />
                </div>
            </div>
            <div className='modal__footer'>
                <BaasicFormControls
                    form={form} 
                    onSubmit={form.onSubmit} 
                    disabled={form.submitting || form.validating} 
                    label="Submit"
                    className='btn btn--med btn--primary'
                />
                <BaasicButton
                    className='btn btn--med btn--light'
                    label={t('EDIT_FORM_LAYOUT.CANCEL')}
                    onClick={() => modalParams.close()}
                />
            </div>
        </section>
    )
}
 
FacilityOrderTemplateAddNoteModalTemplate.propTypes = {
    facilityOrderTemplateAddNoteModalStore: PropTypes.object,
    t: PropTypes.func
};

export default defaultTemplate(FacilityOrderTemplateAddNoteModalTemplate);
